/**
  * @desc Responsive image script, servering the image depending on parent-wrapper width and aspect-ratio parameter
  * html example <figure class="top-image responsiveimg" data-imgsrc="@imageUrl" data-ratio="57" data-alt="image caption"></figure>
  * js example novicell.responsiveImages.init()
  * @author Danni Larsen - DLA, JHA - Jonas Havmøller
  * @return <img>-tag inside selector
  * @requires jquery@1.11.3
  * @note: Remember to run this on resize too and remember to add and image-tag in a no-script-tag for older browsers
*/


var novicell = novicell || {};

novicell.responsiveImages = new function () {
    var self = this;

    this.init = function () {

        $('.responsiveimg').each(function () {
            var $this = $(this);

            if ($this.attr('lazyload') == null) {
                self.contructImage($this);

            } else {
                self.setFigureSkeleton($this);
            }

        });

    };

    this.contructImage = function (el, w, ratio, ratioRnd) {

        // Calc the vars if we dont already got them 
        w = w || el.width() !== 0 ? el.width() : $(el).parent().width(); // If the value is null, take the width of parent container
        ratio = ratio || el.attr('data-ratio') || "";
        ratioRnd = ratioRnd || Math.round(w / 100 * ratio);


        var hString = ratio !== "" ? '&height=' + ratioRnd : "";
        var src = el.attr('data-imgsrc').replace("cropmode=percentage", "cropmode=crop");
        var wRnd = Math.round(w / 50) * 50;
        var greyScale = el.attr('greyscale') !== "" ? "" : "&filter=greyscale";
        var alt = el.attr('data-alt') || "";

        // Reset the min-height to avoid any odd heights on resize
        el.css('min-height', 0);

        // Init the image
        if (el.hasClass('bg-image')) {
            // If its a background image apply the style to the parent div
            el.closest('div').attr('style', 'background: url("' + src + '&width=' + wRnd + hString + greyScale + '&quality=100") center center no-repeat; background-size: cover;');
        } else {
            el.html('<img src="' + src + '&width=' + wRnd + hString + greyScale + '&quality=100" alt="' + alt + '">');
        }

        el.css('opacity', '1');
    };

    this.setFigureSkeleton = function (el) {

        var w = el.width() != 0 ? el.width() : $(el).parent().width(); // If the value is null, take the width of parent container
        var ratio = el.attr('data-ratio') || "";
        var ratioRnd = Math.round(w / 100 * ratio);
        var hRnd = Math.round(ratioRnd / 10) * 10;

        el.css('min-height', ratioRnd);
        el.css('opacity', '0');
        self.lazyloadImages(el, w, ratio, ratioRnd);

    };

    this.lazyloadImages = function (el, w, ratio, ratioRnd) {
        $(el).each(function () {
            var $this = $(this);

            if ($this.visible()) {
                $this.removeAttr('lazyload');
                self.contructImage($this, w, ratio, ratioRnd);
            }


        });


    };

};



novicell.responsiveLazyloadImage = novicell.responsiveLazyloadImage || function () {
    var lastRefreshWidth = 0;
    var refreshWidth = 50;

    function onScroll() {
        $('.responsiveLazyload').each(function () {
            loadImage($(this));
        });
    }

    function onLoad() {
        $('.responsiveLazyload').each(function () {
            var $figure = $(this).parent();

            if ($figure.visible(true) || $(this).data("load") === "always") {
                loadImage($(this), true);
            } else {
                constructPlaceholder($figure);
            }
        });
    }

    function onResize(callback) {
        if (window.innerWidth > lastRefreshWidth + refreshWidth || window.innerWidth < lastRefreshWidth - refreshWidth) {
            $('.lazyResizeReload').each(function () {
                constructImage($(this));
                constructPlaceholder($(this));
                if (typeof callback == 'function') {
                    callback();
                }
            });
            lastRefreshWidth = window.innerWidth;
        }
    }

    // Loads the image.
    function loadImage($element, isVisible) {
        var $this = $element;
        var $figure = $this.parent();

        if (isVisible || $figure.visible(true) || $this.data("load") === "always") {
            if ($this.first()) {
                $this.remove();
                constructImage($figure);
                lastRefreshWidth = window.innerWidth;
                $figure.addClass('lazyResizeReload');
            }
        }
    }

    function constructImage(figure) {
        var $image = new Image();
        var $figure = $(figure);

        //data variables and images settings
        var width, maxWidth, heightRatio, focalPoint, mode, filter, quality, height, isBackgroundImage = false;

        var $parent = $figure.data('parent') ? $figure.closest($figure.data('parent')) : null;
        isBackgroundImage = $figure.data('is-background') ? true : false;
        width = $figure.width() !== 0 ? figure.width() : $figure.parent().width();
        heightRatio = $figure.data('height-ratio') !== 0 ? $figure.data('height-ratio') : null;
        height = $parent ? $parent.height() : null;
        focalPoint = $figure.data('focalpoint');
        mode = $figure.data('mode');
        filter = $figure.data('filter');
        quality = $figure.data('quality') || 100;

        var newImageSrc = $figure.data('src');
        newImageSrc += focalPoint ? nextQuerySign(newImageSrc) + "center=" + focalPoint : "";
        newImageSrc += mode ? nextQuerySign(newImageSrc) + "mode=" + mode : "";
        newImageSrc += filter ? nextQuerySign(newImageSrc) + "filter=" + filter : "";
        newImageSrc += nextQuerySign(newImageSrc) + "quality=" + quality;

        $figure.find('img').remove();

        // Append the image as a background or as a <img>
        if (isBackgroundImage && $parent) {
            var bgSrc = newImageSrc;
            bgSrc += height ? nextQuerySign(bgSrc) + "height=" + height : "";
            bgSrc += mode ? nextQuerySign(bgSrc) + "width=" + width : "";

            $parent.css('background-image', 'url("' + bgSrc + '")');

        }
        else {
            // Add attributes only needed when pretending an image
            maxWidth = $figure.data('original-width');
            if (width > maxWidth) {
                width = maxWidth;
                $figure.addClass('contain-width');
            }

            newImageSrc += mode ? nextQuerySign(newImageSrc) + "width=" + width : "";
            newImageSrc += height && !heightRatio ? nextQuerySign(newImageSrc) + "height=" + height : "";
            newImageSrc += heightRatio !== null ? nextQuerySign(newImageSrc) + "height=" + heightRatio * width : "";

            $image.src = newImageSrc;
            $figure.prepend($image);
            $image = $figure.find('img');
            $image.css('opacity', '0');
            // Fade the image
            $image.on('load', function (event) {
                $image.css('opacity', '1');
            });

            $image.attr('class', $figure.data('class'));
            $image.attr('alt', $figure.data('alt'));
            $image.attr('title', $figure.data('title'));
            $image.attr('property', 'contentUrl');
        }
    }

    function nextQuerySign(url) {
        return url.indexOf("?") > -1 ? "&" : "?";
    }

    function constructPlaceholder(figure) {
        var $el = figure;
        var width, heightRatio, maxWidth;
        var height = 0;

        // Calc the height
        maxWidth = figure.data('original-width');
        width = figure.width() !== 0 ? figure.width() : $(figure).parent().width();
        width = width > maxWidth ? maxWidth : width;
        heightRatio = $el.data('height-ratio');

        if (width && heightRatio) {
            height = heightRatio * width;
        }

        // Set the height
        if (height > 0) {
            $el.css('minHeight', height);
        }
    }

    // public functions:
    return {
        onScroll: onScroll,
        onResize: onResize,
        onLoad: onLoad
    };
}();